import { render } from "./CreateSection.vue?vue&type=template&id=fccc5daa"
import script from "./CreateSection.vue?vue&type=script&lang=js"
export * from "./CreateSection.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/TheIdFactory/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__